import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";
import RequestQuotationModal from "./RequestQuotationModal";
import products from "../data/products";

// Import all possible category images
import { herobg1, herobg2, herobg3, herobg4 } from "./index";

const categoryData = {
  "organic-products": {
    title: "ORGANIC FERTILIZERS",
    image: herobg1,
    category: "organic_fertilizers",
  },
  "cocopit-coir": {
    title: "COCOPEAT - COIR PRODUCTS",
    image: herobg4,
    category: "cocopeat_coir_products",
  },
  "herbal-products": {
    title: "HERBAL PRODUCTS",
    image: herobg2,
    category: "herbal_products",
  },
  "bagasse-tableware": {
    title: "BAGASSE TABLEWARE",
    image: herobg3,
    category: "bagasse_tableware",
  },
};

const Categories = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const currentCategory =
    categoryData[category] || categoryData["organic-products"];

  // Filter products based on the current category
  const filteredProducts = products.filter(
    (product) => product.category === currentCategory.category
  );

  const [isQuotationModalOpen, setIsQuotationModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openQuotationModal = (product) => {
    setSelectedProduct(product);
    setIsQuotationModalOpen(true);
  };

  const closeQuotationModal = () => setIsQuotationModalOpen(false);

  const navigateToProductDetail = (product) => {
    navigate(`/products/${product.id}`);
  };

  return (
    <div className="min-h-screen bg-[#FBF1EB]">
      {/* Hero Section for Category */}
      <div className="relative w-full h-[50vh] min-h-[400px] overflow-hidden">
        <div className="relative w-full h-full">
          <img
            src={currentCategory.image}
            alt={currentCategory.title}
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute left-8 bottom-8 z-20">
            <div className="bg-[#D9B58F] p-4 md:p-6 text-white border-r-8 border-[#B99063]">
              <h1 className="text-xl md:text-2xl font-bold text-[#000000]">
                SPECIALISED IN
              </h1>
              <h2 className="text-xl md:text-2xl font-bold text-[#000000]">
                {currentCategory.title}
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <section className="w-full py-12 px-4 md:px-8 bg-[#FBF1EB]">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl text-center font-bold text-[#73340E] mb-8">
            {currentCategory.title}
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredProducts.map((product) => (
              <div key={product.id} className="flex flex-col items-center">
                <div
                  className="w-full aspect-square relative mb-2 cursor-pointer group"
                  onClick={() => navigateToProductDetail(product)}
                >
                  <div className="absolute inset-0 flex items-center justify-center">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="max-w-full max-h-full object-contain border-4 border-[#8F5D3F] rounded-lg group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>
                <h3 className="text-lg font-medium text-[#34302B] mb-2 text-center">
                  {product.name}
                </h3>
                <Button
                  className="bg-[#8b5e3c] hover:bg-[#8b5e3c] text-white text-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/products/${product.id}`);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  View Details
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modals */}
      <RequestQuotationModal
        isOpen={isQuotationModalOpen}
        onClose={closeQuotationModal}
        productName={selectedProduct?.name || ""}
        productId={selectedProduct?.id || ""}
      />
    </div>
  );
};

export default Categories;
